import LandCornerPicker from "../ones/LandCornerPicker";

export default function View(props) {

	return (
		<div
			style={{
				width: "100%",
				height: "100%",
				overflow: "scroll",
				paddingTop: "20px",
				paddingBottom: "calc(var(--topBarHeight) + 40px)",
			}}
			className="mNoScrollBar"
		>
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<LandCornerPicker/>
					</div>
				</div>
			</div>
		</div>
	)
}
